export const FEATURE_GATE_METADATA: Record<string, string> = {
  entity: "Entities",
  feature: "Features & Events",
  cm_copilot: "[deprecated] Case Management Copilot",
  byok: "BYOK LLM Credentials",
};

export const getFeatureGateTitle = (key: string): string =>
  FEATURE_GATE_METADATA[key] ?? key;
